import React from "react";
import TextInput from "../../Components/TextInput/TextInput";
import RegistrationForm from "../../Components/RegistrationForm/RegistrationForm";
import call from "../../API/API";
import jwt_decode from "jwt-decode";
import InputErrorMessage from "../../Components/InputErrorMessage/InputErrorMessage";
import GooLoader from "../../Components/GooLoader/GooLoader";
import PasswordInput from "../../Components/PasswordInput/PasswordInput";
import { Helmet } from "react-helmet-async";
import { psw_regex, email_regex } from "../../regex/regex";
import "./Login.css";

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      errors: {
        emailError: "",
        pswError: "",
        formError: "",
      },
      isLoading: true,
    };

    this.handleEmailOnChange = this.handleEmailOnChange.bind(this);
    this.handlePasswordOnChange = this.handlePasswordOnChange.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
  }

  componentDidMount() {
    let token = localStorage.getItem("token");
    if (token) {
      let decoded = jwt_decode(token);
      if (decoded.email_verified === "pending") {
        this.props.history.push("/verify-email");
      } else if (decoded.email_verified === "active") {
        if (decoded.active) {
          call.users_API
            .getPersonalUserMatchingCriteria()
            .then((response) => {
              console.log(response);
              if (response.success) {
                let userData = response.results;
                let { matching_data } = userData;
                const {
                  user_type,
                  city,
                  policy_agreements,
                  name,
                  lastname,
                  email,
                } = userData;
                if (!matching_data) {
                  this.props.history.push("/welcome", {
                    userData: {
                      name: name,
                      lastname: lastname,
                      email: email,
                      user_type: user_type,
                      city: city,
                      policy_agreements: policy_agreements,
                    },
                  });
                } else {
                  this.props.history.push("/dashboard");
                }
              } else {
                this.props.history.push("/error", { error: response.results });
              }
            })
            .catch((err) => {
              this.props.history.push("/error", { error: err.message });
            });
        } else {
          call.users_API.getPersonalUserMatchingCriteria().then((res) => {
            if (res.success) {
              let userData = res.results;
              const {
                user_type,
                city,
                policy_agreements,
                name,
                lastname,
                email,
              } = userData;
              if (!user_type || !city || !policy_agreements) {
                this.props.history.push("/for-founders-by-founders", {
                  userData: {
                    name: name,
                    lastname: lastname,
                    email: email,
                  },
                });
              } else {
                this.props.history.push("/payment", {
                  userData: {
                    name: name,
                    lastname: lastname,
                    email: email,
                    user_type: user_type,
                    city: city,
                    policy_agreements: policy_agreements,
                  },
                });
              }
            } else {
              this.props.history.push("/error", { error: res.results });
            }
          });
        }
      } else {
        this.props.history.push("/error", {
          error: "Cannot identify your email, please try again.",
        });
      }
    } else {
      this.setState({
        isLoading: false,
      });
    }
  }

  handleEmailOnChange(e) {
    this.setState({
      email: e.target.value,
    });
  }

  handlePasswordOnChange(e) {
    this.setState({
      password: e.target.value,
    });
  }

  validateEmail(email) {
    let isValid = email_regex.test(email);
    return isValid;
  }

  validatePassword(psw) {
    let isValid = psw_regex.test(psw);
    return isValid;
  }

  async handleLogin(e) {
    e.preventDefault();

    const { email, password } = this.state;
    //Email validation
    if (email === "") {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          emailError: "Please enter your email",
        },
      }));
    } else if (!this.validateEmail(email)) {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          emailError: "Email should be in correct form (your.name@domain.com)",
        },
      }));
    } else {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          emailError: "",
        },
      }));
    }

    //Password validation
    if (password === "") {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          pswError: "Please enter your password",
        },
      }));
    } else if (!this.validatePassword(password)) {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          pswError: "Password must be 8 characters or more",
        },
      }));
    } else {
      await this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          pswError: "",
        },
      }));
    }

    if (
      this.state.errors.emailError === "" &&
      this.state.errors.pswError === ""
    ) {
      await this.setState(
        (prevState) => ({
          errors: {
            ...prevState.errors,
            formError: "",
          },
        }),
        () => {
          call.users_API
            .login(email, password)
            //We took a response from backend
            .then((response) => {
              //User exists
              if (response.success) {
                let token = response.results;
                localStorage.setItem("token", token);
                let decoded = jwt_decode(token);
                if (decoded.email_verified === "pending") {
                  this.props.history.push("/verify-email");
                } else if (decoded.email_verified === "active") {
                  if (decoded.active) {
                    this.props.history.push("/dashboard");
                  } else {
                    call.users_API
                      .getPersonalUserMatchingCriteria()
                      .then((res) => {
                        if (res.success) {
                          let userData = res.results;
                          const {
                            user_type,
                            city,
                            policy_agreements,
                            name,
                            lastname,
                          } = userData;
                          if (!user_type || !city || !policy_agreements) {
                            this.props.history.push(
                              "/for-founders-by-founders",
                              {
                                userData: {
                                  name: name,
                                  lastname: lastname,
                                  email: email,
                                },
                              }
                            );
                          } else {
                            this.props.history.push("/payment", {
                              userData: {
                                user_type: user_type,
                                city: city,
                                policy_agreements: policy_agreements,
                              },
                            });
                          }
                        }
                      })
                      .catch((err) => {
                        this.props.history.push("/error", { error: err });
                      });
                  }
                }

                //User does not exist
              } else {
                if (response.results === "This user does not exist!") {
                  this.setState((prevState) => ({
                    errors: {
                      ...prevState.errors,
                      emailError: "This email does not exist",
                    },
                  }));
                } else if (
                  response.results === "No matching user found in the database!"
                ) {
                  this.setState((prevState) => ({
                    errors: {
                      ...prevState.errors,
                      pswError: "Password is not correct",
                    },
                  }));
                } else if (response.results === "Error on login!") {
                  this.setState((prevState) => ({
                    errors: {
                      ...prevState.errors,
                      formError:
                        "There was an error on your connection. Please try again.",
                    },
                  }));
                } else {
                  this.setState((prevState) => ({
                    errors: {
                      ...prevState.errors,
                      formError: response.results,
                    },
                  }));
                }
              }
            })
            //Error during call
            .catch((err) => {
              this.props.history.push("/error", { error: err.message });
            });
        }
      );
    }
  }

  checkTokenOnLogin = (token) => {
    let decoded = jwt_decode(token);
    let { active, exp } = decoded;
    return {
      active,
      exp,
    };
  };

  render() {
    return (
      <React.Fragment>
        {this.state.isLoading ? <GooLoader /> : null}
        <RegistrationForm
          containerClassName="container-login"
          hasCounter={false}
          hasQuote={false}
          headerText="Let's login to your account"
          primaryButtonText="Login"
          hasSkip={false}
          handlePrimaryBtnOnClick={this.handleLogin}
          activatePrimaryWithEnter={true}
          showButton={true}
          showRegisterLink={false}
        >
          <Helmet>
            <title>Astronomic Network</title>
            <meta
              name="description"
              content="Austin entrepreneurs helping each other win"
            />
          </Helmet>

          {this.state.errors.formError !== "" ? (
            <div className="form-container-body-row">
              <InputErrorMessage errorText={this.state.errors.formError} />
            </div>
          ) : null}
          <div className="form-container-body-row">
            <TextInput
              id="email"
              label="Email"
              type="email"
              handleTextInputOnChange={this.handleEmailOnChange}
              placeholder="your.email@domain.com"
              required={true}
            />
            {this.state.errors.emailError !== "" ? (
              <InputErrorMessage errorText={this.state.errors.emailError} />
            ) : null}
          </div>
          <div className="form-container-body-row">
            <PasswordInput
              id="password"
              label="Password"
              handleTextInputOnChange={this.handlePasswordOnChange}
              placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
              required={true}
            />
            {this.state.errors.pswError !== "" ? (
              <InputErrorMessage errorText={this.state.errors.pswError} />
            ) : null}
          </div>
        </RegistrationForm>
      </React.Fragment>
    );
  }
}

export default Login;
